import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { localizationConfig } from "./localization-config";
import { detectLocale, setLocaleCookie } from "./locale-cookie";
import { getI18nResources } from "./load-resources";
import { DEFAULT_LOCALE } from "./locales";

export function initI18n() {
  const resources = getI18nResources();
  const supportedLocales = Object.keys(resources);

  void i18n.use(initReactI18next).init({
    resources,
    lng: detectLocale(supportedLocales),
    fallbackLng: DEFAULT_LOCALE,
    keySeparator: false,
    nsSeparator: false,
    contextSeparator: "__rc__",
    pluralSeparator: "__rp__",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  i18n.on("languageChanged", (lng) => {
    if (localizationConfig.isEnabled()) {
      setLocaleCookie(lng);
    }
  });
}

export function updateLocalization(enabled: boolean): void {
  localizationConfig.setEnabled(enabled);
  if (!i18n.isInitialized) {
    return;
  }
  const resources = getI18nResources();
  const supportedLocales = Object.keys(resources);
  const locale = detectLocale(supportedLocales);
  if (i18n.language !== locale) {
    void i18n.changeLanguage(locale);
  }
}
